import { chatRoutePercentage } from 'globals/styles';

const styles = {
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    height: `${chatRoutePercentage}%`,
  },
  wrapNoCTA: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    height: `${chatRoutePercentage}%`,
    paddingBottom: 29, // 30-1px to hide the bottom border
  },
};

export default styles;
